import {
  loadPatientById,
  loadWorkflowTimeline,
  loadAppointmentById
} from '../../Appointment/reducers/actions';

export default {
  loadPatientById,
  loadWorkflowTimeline,
  loadAppointmentById
};